<template>
  <div class="flex items-center justify-between px-4">
    <template v-if="side === 'right'">
      <div
        v-if="!mq.isMobile"
        class="flex items-center gap-2"
      >
        <ButtonCircle
          action="close"
          :data-test="`sidebar-${data_test}-close`"
          @onClick="$emit('close')"
        />
        <ButtonCircle
          v-tooltip.bottom="is_pinned ? $t('notification.labels.unpinSidebar') : $t('notification.labels.pinSidebar')"
          action="pin"
          :is_active="is_pinned"
          is_toggle
          @onClick="$emit('toggle-pin')"
        />
      </div>
      <span class="text-xl font-semibold">
        {{ title }}
      </span>
      <ButtonCircle
        v-if="mq.isMobile"
        action="close"
        :data-test="`sidebar-${data_test}-close`"
        @onClick="$emit('close')"
      />
    </template>

    <template v-else>
      <span class="text-xl font-semibold">
        {{ title }}
      </span>
      <div class="flex items-center gap-2">
        <ButtonCircle
          v-if="show_expand_toggle"
          v-tooltip.bottom="
            is_expanded ? $t('notification.labels.compactView') : $t('notification.labels.expandedView')
          "
          action="expand"
          :is_active="is_expanded"
          is_toggle
          @onClick="$emit('toggle-expand')"
        />
        <ButtonCircle
          v-if="!mq.isMobile"
          v-tooltip.bottom="is_pinned ? $t('notification.labels.unpinSidebar') : $t('notification.labels.pinSidebar')"
          action="pin"
          :is_active="is_pinned"
          is_toggle
          @onClick="$emit('toggle-pin')"
        />
        <ButtonCircle
          action="close"
          :data-test="`sidebar-${data_test}-close`"
          @onClick="$emit('close')"
        />
      </div>
    </template>
  </div>
</template>

<script setup>
import ButtonCircle from '@/app/shared_components/buttons/ButtonCircle.vue';
import { useMqService } from '@/plugins/mq';

const mq = useMqService();

defineProps({
  title: { type: String, required: true },
  is_pinned: { type: Boolean, default: false },
  is_expanded: { type: Boolean },
  show_expand_toggle: { type: Boolean },
  side: { type: String, default: 'left', validator: (v) => ['left', 'right'].includes(v) },
  data_test: { type: String, default: 'sidebar' },
});

defineEmits(['close', 'toggle-pin', 'toggle-expand']);
</script>
